import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from "../features/user/UserSlice";
import modalReducer from "../features/modal/ModalSlice";
import SIPConfigReducer from "../features/SIP/SIPConfigSlice";
import SIPCallsReducer from "../features/SIP/SIPCallsSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { thunk } from "redux-thunk";

const rootPersistConfig = {
  key: "root",
  storage,
  whitelist: ["userInfo", "SIPConfig"], // Correctly configured whitelist
};

const rootReducer = combineReducers({
  userInfo: userReducer,
  modal: modalReducer,
  SIPConfig: SIPConfigReducer,
  SIPCalls: SIPCallsReducer,
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }).concat(thunk),
});

export const persistor = persistStore(store);

persistor.subscribe(() => {
  store.getState();
  //   const state = store.getState();
  // console.log("Rehydrated state:", state);
});
